module.exports = __webpack_public_path__ + "img/wscq-currency-guide-1.ed37e51e.png";